export default __webpack_public_path__ + "static/Ong Lay Fung-43b8599f4c10ca543f3363b19f083bc8.webp";